import React from "react";
import SeoHead from '../component/SeoHead';
import metaData from '../data/Meta.json';
import { jsonLdByPath } from '../data/SchemaTag.js';
import Link from "next/link";
export async function getServerSideProps(context) {
  const path = context.resolvedUrl.toLowerCase();

  const matchedMeta = metaData.find(item => item.url?.toLowerCase().endsWith(path)) || {};

  const pageJson = jsonLdByPath.find(item => item.url?.toLowerCase().endsWith(path));

  const title = matchedMeta?.title || 'Millance';
  const description = matchedMeta?.description || 'Trade smarter with Millance.';
  const url = matchedMeta?.url || `https://millance.com${path}`;
  const jsonLd = pageJson || null;

  return {
    props: { meta: { title, description, url }, jsonLd, }
  };
}
const Introbroker = ({ meta, jsonLd }) => {

  return (
    <>
      <SeoHead title={meta.title} description={meta.description} jsonLd={jsonLd} url={meta.url} />
      <div className="introbroker">
        <section className="introbro">
          <div className="intorbrobanner">
            <div className="container">
              <div className="row align-items-center">
                <div className="col-md-12 col-lg-6 d-flex flex-column justify-content-center">
                  <h1 className="mb-3">Introducing Broker</h1>
                  <p className="text-left  mb-3">
                    Expand your network with Millance LTD and offer your clients exceptional technical services, liquidity, and support.
                  </p>
                </div>
                <div className="col-md-12 col-lg-6">
                  <img
                    src={"/images/introbroker/intro.png"}
                    alt="logo"
                    className="img-fluid"
                  />
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* bannersecend */}
        {/* mainsec */}
        <section className="inbro mt-5">
          <div className="container">
            <div className="inbrosub">
              <h2 className="text-center mb-3">
                Grow and Succeed with Millance LTD’s IB Program!
              </h2>
              <p className="text-center">
                Partner with Millance LTD to bridge the gap between clients and brokers while offering exceptional services, support, and liquidity. Our Introducing Broker program is designed to help you thrive.
              </p>
            </div>
          </div>
        </section>
        <section className="inbroicons">
          <div className="container">
            <div className="inbrosubicons pt-4">
              <div className="row justify-content-center mt-3">
                <div className="col-md-12 col-lg-3">
                  <div className="iconintro1 d-flex align-items-center">
                    <div className="imginb">
                      <img
                        src={"/images/introbroker/tradecommision1.png"}
                        alt="logo"
                        className="img-fluid"
                      />
                    </div>
                    <div className="parainb">
                      <p>
                        Seamless Daily <br />
                        Commission Payouts
                      </p>
                    </div>
                  </div>
                </div>
                <div className="col-md-12 col-lg-3">
                  <div className="iconintro1 d-flex align-items-center">
                    <div className="imginb">
                      <img
                        src={"/images/introbroker/tradesearch.png"}
                        alt="logo"
                        className="img-fluid"
                      />
                    </div>
                    <div className="parainb">
                      <p>
                        Competitive Trading
                        <br />Conditions
                      </p>
                    </div>
                  </div>
                </div>
                <div className="col-md-12 col-lg-3">
                  <div className="iconintro1 d-flex align-items-center">
                    <div className="imginb">
                      <img
                        src={"/images/introbroker/uncappedcomm.png"}
                        alt="logo"
                        className="img-fluid"
                      />
                    </div>
                    <div className="parainb">
                      <p>
                        Unlimited Earning Potential with
                        <br /> No Commission Caps
                      </p>
                    </div>
                  </div>
                </div>
                <div className="col-md-12 col-lg-3">
                  <div className="iconintro2 d-flex align-items-center">
                    <div className="imginb">
                      <img
                        src={"/images/introbroker/transparenttrade.png"}
                        alt="logo"
                        className="img-fluid"
                      />
                    </div>
                    <div className="parainb">
                      <p>
                        Transparent Program with  <br />
                        No Hidden Restrictions
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="insubbrwk">
          <div className="introbrowk mt-5">
            <div className="container">
              <div className="intsubwk">
                <div className="row align-items-center">
                  <div className="col-md-12 col-lg-6">
                    <img
                      src={"/images/introbroker/introbroker.png"}
                      alt="logo"
                      className="img-fluid"
                    />
                  </div>
                  <div className="col-md-12 col-lg-6 m-auto">
                    <h2 className="mb-3">
                      How Does the Introducing Broker (IB) Program Work?
                    </h2>
                    <p>
                      The Millance LTD Introducing Broker (IB) program is designed to provide you with volume-based rebates for every copy trade made by the clients you refer to Millance LTD. We offer flexible incentive structures tailored to meet your needs.
                    </p>
                    <p>
                      We offer some of the most competitive rebates in the market because we truly value your partnership, providing clear IB reporting and a robust IB infrastructure for your success.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="brodesign mt-0">
          <div className="container">
            <div className="subbrokerdesign">
              <h2 className="mb-3 text-center">
                Who is the Introducing Broker Program Designed For?              </h2>
              <p className="text-center">
                The Millance LTD Introducing Broker (IB) program is ideal for individuals or organizations with a broad network of traders or referral partners, looking to leverage their audience to drive growth and earnings.
              </p>

              <div className="parentsec">
                <h4 className="text-center">Some of our partners include:</h4>
                <div className="parentsecli row mt-3 d-flex justify-content-center">
                  {/* <div className="col-md-12 col-lg-4">
                    <div className="d-flex partnerslist align-items-center">
                      <div className="partnericon1">
                        <img
                          src={"/images/introbroker/tradeeducator.png"}
                          alt="logo"
                          className="img-fluid mx-2"
                        />
                      </div>
                      <div className="parpara">
                        <p>Educators</p>
                      </div>
                    </div>
                  </div> */}
                  {/* <div className="col-md-12 col-lg-4">
                    <div className="d-flex partnerslist align-items-center">
                      <div className="partnericon1">
                        <img
                          src={"/images/introbroker/tradesignal.png"}
                          alt="logo"
                          className="img-fluid  mx-2"
                        />
                      </div>
                      <div className="parpara">
                        <p>Signal Service Providers</p>
                      </div>
                    </div>
                  </div> */}
                  <div className="col-md-12 col-lg-4">
                    <div className="d-flex partnerslist align-items-center">
                      <div className="partnericon1">
                        <img
                          src={"/images/introbroker//fitechicon1.png"}
                          alt="logo"
                          className="img-fluid  mx-2"
                        />
                      </div>
                      <div className="parpara">
                        <p>FinTech Frims</p>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-12 col-lg-4">
                    <div className="d-flex partnerslist align-items-center">
                      <div className="partnericon1">
                        <img
                          src={"/images/introbroker/tradereferrs.png"}
                          alt="logo"
                          className="img-fluid  mx-2"
                        />
                      </div>
                      <div className="parpara">
                        <p> Referrers</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className=" parentsecli row mt-3">
                  {/* <div className="col-md-12 col-lg-4">
                    <div className="d-flex partnerslist align-items-center">
                      <div className="partnericon1">
                        <img
                          src={"/images/introbroker/tradereabeta.png"}
                          alt="logo"
                          className="img-fluid  mx-2"
                        />
                      </div>
                      <div className="parpara">
                        <p> Rebate Providers</p>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-12 col-lg-4">
                    <div className="d-flex partnerslist align-items-center">
                      <div className="partnericon1">
                        <img
                          src={"/images/introbroker/tradeea.png"}
                          alt="logo"
                          className="img-fluid  mx-2"
                        />
                      </div>
                      <div className="parpara">
                        <p> EA Providers</p>
                      </div>
                    </div>
                  </div> */}

                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="insbrkey mt-5">
          <div className="container-fluid">
            <div className="keybene">
              <h2 className="text-center">
                Top Advantages of the Millance LTD Introducing Broker Program              </h2>
              <div className="row align-items-center justify-content-center mt-4">
                <div className="col-md-12 col-lg-4">
                  <div className="seckey1">
                    <span>max</span>
                    <span>
                      {" "}
                      <strong>$20</strong>
                    </span>
                    <span>Rebates</span>
                  </div>
                </div>
                <div className="col-md-12 col-lg-4">
                  <div className="seckey1">
                    <span>Multi-lingual</span>
                    <span>
                      {" "}
                      <strong>Support</strong>
                    </span>
                    <span>Material</span>
                  </div>
                </div>
                <div className="col-md-12 col-lg-4">
                  <div className="seckey1">
                    <span>Dedicated</span>
                    <span>
                      {" "}
                      <strong>Account</strong>
                    </span>
                    <span>Managers</span>
                  </div>
                </div>
              </div>
              {/* <div className="row align-items-center justify-content-center mt-5">
                <div className="col-md-12 col-lg-4">
                  <div className="seckey1">
                    <span>Up to</span>
                    <span>
                      {" "}
                      <strong>$3</strong>
                    </span>
                    <span>Rebates</span>
                  </div>
                </div>
                <div className="col-md-12 col-lg-4">
                  <div className="seckey1">
                    <span>Multi-lingual</span>
                    <span>
                      {" "}
                      <strong>Support</strong>
                    </span>
                  
                  </div>
                </div>
                <div className="col-md-12 col-lg-4">
                  <div className="seckey1">
                    <span>Dedicated</span>
                    <span>
                      {" "}
                      <strong>Account</strong>
                    </span>
                    <span>Managers</span>
                  </div>
                </div>
              </div> */}
              <div className="marklis mt-5">
                <div className="row align-items-center">
                  <div className="col-lg-3"></div>
                  <div className="col-md-12 col-lg-6">
                    <div className="marklisitem1">
                      <p>

                        <img
                          src={"/images/introbroker/clientwithdraw.png"}
                          alt="logo"
                          className="img-fluid mx-2"
                        />
                        Client withdrawals and transfers are processed quickly for your convenience.

                      </p>
                    </div>
                  </div>
                  <div className="col-lg-3"></div>

                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="ib mt-5">
          <div className="container">
            <div className="ibvintage">
              <div className="row align-items-center">
                <div className="col-md-12 col-lg-6">
                  <h2 className="mb-3">Become an Introducing Broker with Millance LTD Today</h2>
                  <p>
                    Our Introducing Broker (IB) program is designed to scale with your business, whether you&apos;re new to the referral industry or an experienced professional. With the most competitive, volume-based rebates in the market, Millance LTD provides the tools and support you need to grow your business. We&apos;re committed to building strong, lasting partnerships and helping you succeed every step of the way.
                  </p>
                </div>
                <div className="col-md-12 col-lg-6">
                  <img
                    src={"/images/introbroker/introbroker2.png"}
                    alt="logo"
                    className="img-fluid"
                  />
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="becomeib mt-3">
          <div className="container">
            <div className="becomeibinsub">
              <h2 className="text-center">
                How to Become an Introducing Broker
              </h2>
              <div className="row align-items-center mt-5">
                <div className="col-md-12 col-lg-4">
                  <div className="sign1 d-flex align-items-center">
                    <div className="becom1 mx-3">
                      <img
                        src={"/images/introbroker/ibsignup.png"}
                        alt="logo"
                        className="img-fluid"
                      />
                    </div>
                    <div className="becom2">
                      <h5 className="mb-2">Signup</h5>
                      <p>
                        Join our IB program and take the first step toward growing your business with Millance LTD.
                      </p>
                    </div>
                  </div>
                </div>
                <div className="col-md-12 col-lg-4">
                  <div className="sign1 d-flex align-items-center">
                    <div className="becom1 mx-3">
                      <img
                        src={"/images/introbroker/referib.png"}
                        alt="logo"
                        className="img-fluid"
                      />
                    </div>
                    <div className="becom2">
                      <h5 className="mb-2">Refer Clients</h5>
                      <p>
                        Share your personalized tracking links to direct clients to our optimized landing pages.
                      </p>
                    </div>
                  </div>
                </div>
                <div className="col-md-12 col-lg-4">
                  <div className="sign1 d-flex align-items-center">
                    <div className="becom1 mx-3">
                      <img
                        src={"/images/introbroker/earnmoreib.png"}
                        alt="logo"
                        className="img-fluid"
                      />
                    </div>
                    <div className="becom2">
                      <h5 className="mb-2">Earn More</h5>
                      <p>
                        Enjoy lifetime rebates based on the trading activities of the clients you refer.
                      </p>
                    </div>
                  </div>
                </div>
                <Link href="https://crm.millance.com/register">
                  <button type="button" className="btn btn-become mt-4 mb-5">
                    Become Ib
                  </button>
                </Link>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default Introbroker;
